import { connect } from 'react-redux';

import { NormalizedStore } from '@store/entity/entity.types';
import { changeJourneyParam } from '@store/yourJourney/actions';
import { yourJourneySelectors } from '@store/yourJourney/selectors';

import { Packages } from './Packages';

const mapDispatchToProps = (dispatch) => ({
  changeJourneyParam: (param, value) => changeJourneyParam(param, value)(dispatch),
});

const mapStateToProps = (state: NormalizedStore) => {
  const journeyParams = yourJourneySelectors.getParsedJourneyParams(state);

  return {
    journeyParams,
  };
};

const _connected: any = connect(mapStateToProps, mapDispatchToProps)(Packages);
export default _connected;
